var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../../common";
export class TodaySportsRetriever extends Retriever {
    constructor(baseRetriever, timeZoneObservable, clock, sportBffQueryFactory, sportApiQueryFactory) {
        super();
        this.baseRetriever = baseRetriever;
        this.timeZoneObservable = timeZoneObservable;
        this.clock = clock;
        this.sportBffQueryFactory = sportBffQueryFactory;
        this.sportApiQueryFactory = sportApiQueryFactory;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.baseRetriever.activate();
            yield this.timeZoneObservable.observe((timeZone) => {
                const sportBffQueryFactory = () => {
                    const from = this.clock.getBeginningOfTodayForTimeZone(timeZone);
                    return this.sportBffQueryFactory(from);
                };
                const sportApiQueryFactory = this.sportApiQueryFactory(() => this.clock.getBeginningOfTodayForTimeZone(timeZone));
                return this.baseRetriever.refresh(state, sportBffQueryFactory, sportApiQueryFactory);
            });
        });
    }
    deactivate() {
        this.baseRetriever.deactivate();
    }
}
//# sourceMappingURL=TodaySportsRetriever.js.map